import { useCallback, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';

import { HeadContext } from '../context/head';

export const HeadProvider = ({ children }: { children: React.ReactNode }) => {
  const [title, setTitle] = useState<string>('');
  const [metaDescription, setMetaDescription] = useState<string>('');

  const setHelmetTitle = useCallback((title: string) => {
    setTitle(title);
  }, []);

  const setHelmetMetaDescription = useCallback((desc: string) => {
    setMetaDescription(desc);
  }, []);

  const contextValue = useMemo(
    () => ({
      setHelmetTitle,
      setHelmetMetaDescription,
    }),
    [setHelmetMetaDescription, setHelmetTitle]
  );

  return (
    <HeadContext.Provider value={contextValue}>
      <Helmet>
        <title>
          {title ? `${title} - ` : ''}
          mavue
        </title>
        {metaDescription && <meta name="description" content={metaDescription} />}
      </Helmet>
      {children}
    </HeadContext.Provider>
  );
};
